import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.28367 1.13401C5.48195 0.458633 6.43324 0.443777 6.65253 1.11262L7.66804 4.21005L10.7939 4.24188C11.4696 4.24876 11.7613 5.10119 11.2315 5.52061L8.72593 7.50415L9.6772 10.6237C9.87948 11.287 9.11571 11.8224 8.56117 11.4059L6.01784 9.49598L3.70771 11.2055C3.1612 11.6099 2.41131 11.0973 2.58966 10.4413L3.40151 7.45487L0.812407 5.49492C0.26448 5.08014 0.557816 4.20664 1.24503 4.20664H4.38157L5.28367 1.13401ZM5.98502 2.20625L5.26263 4.66678C5.17302 4.972 4.89298 5.18164 4.57488 5.18164H2.01396L4.12907 6.78277C4.36234 6.95936 4.46487 7.25999 4.38813 7.54231L3.72563 9.97928L5.59261 8.59773C5.84745 8.40915 6.1959 8.41038 6.4494 8.60075L8.51373 10.151L7.74195 7.62008C7.65594 7.33801 7.75146 7.03205 7.98267 6.84902L10.0538 5.20939L7.47304 5.18312C7.16591 5.17999 6.89491 4.98154 6.79923 4.68968L5.98502 2.20625Z"
      fill="#B14A00"
    />
  </svg>
);

const StarIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default StarIcon;
